import React, { useCallback, useEffect, useRef, useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import Login from "../../app/auth/Login";
import img from "../../app/assets/img/404.jpg";
import Markdown from "react-markdown";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MetadataTable from "../../components/reuseable/MetadataTable";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const RetailDisplayChecker = () => {
  const [fileName, setFileName] = useState(""); // State to store file name
  const [file, setFile] = useState(null); // Store selected file
  const [uploading, setUploading] = useState(false); // Track upload status
  const [message, setMessage] = useState(""); // Store success/error message
  const [Download, setDownload] = useState(null);
  const [base64img, setbase64img] = useState(null);
  const [data, setData] = useState(null);
  const [complianceAssessment, setComplianceAssessment] = useState(null);
  const [DisplayTypeResult, setDisplayTypeResult] = useState(null);

  const navigate = useNavigate();
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setDownload(null);
      setbase64img(null);
      setDisplayTypeResult(null);
      setComplianceAssessment(null);
      setMessage("");
      setFile(acceptedFiles[0]); // Store file
      setFileName(acceptedFiles[0].name); // Set the file name
      setMessage(""); // Clear previous messages
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "image/jpeg": [], "image/png": [] }, // Restrict to JPG and PNG files
    multiple: true, // Allow only one file at a time (optional)
  });

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a PDF file first.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file); // Key should match the backend API

    try {
      setUploading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PYTHON_BACKEND_URL}/retailanalyze`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response);
      if (response.status === 200) {
        console.log("response", response);
        // console.log("data",response.data)
        const imageData = response.data; // Assuming the response contains CSV data
        console.log("imageData", imageData);
        const compliance_assessment =
          imageData && imageData.compliance_assessment;
        const display_type_result = imageData && imageData.display_type_result;

        // const jsonParse = compliance_assessment && compliance_assessment !== '' ? JSON.parse(compliance_assessment) : null;
        console.log("jsonParse", compliance_assessment);

        setComplianceAssessment(compliance_assessment);
        setDisplayTypeResult(display_type_result);
        const input_image_base64 = imageData["input_image_base64"];
        console.log("jsonPainput_image_base64rse", input_image_base64);

        setData(imageData);
        setbase64img(input_image_base64);
        // if (csvData) {
        //   downloadCSV(csvData);
        // }        // navigate(`/details?responseID=${response.data.responseID}`)
      }
    } catch (error) {
      setMessage("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };
  const timestamp = new Date()
    .toISOString()
    .replace(/[-:T.]/g, "")
    .slice(0, 14); // YYYYMMDDHHMMSS

  const handleDownload = () => {
    if (!base64img) return;

    const link = document.createElement("a");
    link.href = base64img;
    link.download = "downloaded_image.png"; // Set filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // console.log("complianceAssessment",complianceAssessment)

  const KeyValueTable = ({ data }) => {
    console.log(data); // ✅ This will now work
  
    return (
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "8px",background:"#333" }}>Key</th>
            <th style={{ border: "1px solid #ccc", padding: "8px",background:"#333" }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>{row.key}</td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  

  const transformData = (rawObj) => {
    const keys = Object.keys(rawObj);
    return keys.map((value, index) => ({
      key: keys,
      value
    }));
  };

  
  
  return (
    <>
      <AuthenticatedTemplate>
        <div
          id="homePage"
          style={{ overflow: "hidden", height: "var(--app-height)" }}
        >
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />

              <div style={{ overflowY: "auto" }} id="mainHome">
                <div
                  style={{
                    height: "100%",
                    alignContent: "baseline",
                    alignItems: "baseline",
                    textAlign: "center",
                    gap: "2rem",
                    display: "grid",
                    width: "90%",
                    margin: "auto",
                  }}
                >
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "700",
                      marginTop: "1rem",
                    }}
                  >
                    Upload Your Image File{" "}
                  </div>
                  <div
                    {...getRootProps()}
                    style={{
                      border: "2px dashed #bb1ccc",
                      borderRadius: "8px",
                      padding: "5rem",
                      textAlign: "center",
                      backgroundColor: "#f8f9fa",
                      cursor: "pointer",
                    }}
                  >
                    <input {...getInputProps()} />
                    <CloudUploadIcon sx={{ fontSize: 50, color: "#bb1ccc" }} />
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      Drop your File here or{" "}
                      <span style={{ color: "#bb1ccc", cursor: "pointer" }}>
                        browse
                      </span>
                      .
                    </Typography>

                    <Button
                      variant="contained"
                      sx={{ mt: 2, backgroundColor: "#bb1ccc" }}
                    >
                      Upload
                    </Button>

                    {/* Display File Name After Upload */}
                    {fileName && (
                      <Typography
                        variant="body1"
                        sx={{ mt: 2, color: "#bb1ccc" }}
                      >
                        File Name: {fileName}
                      </Typography>
                    )}
                  </div>

                  {file !== null && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      {/* Upload Button */}
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{
                          mt: 2,
                          marginLeft: "10px",
                          backgroundColor: "#bb1ccc",
                        }}
                        onClick={handleUpload}
                        disabled={
                          uploading ||
                          file == null ||
                          Download !== null ||
                          base64img !== null
                        }
                      >
                        {uploading ? <CircularProgress size={24} /> : "Check"}
                      </Button>

                      {base64img && (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            mt: 2,
                            marginLeft: "10px",
                            backgroundColor: "#bb1ccc",
                          }}
                          onClick={handleDownload}
                        >
                          {"Download"}
                        </Button>
                      )}

                      {/* <Button
                              variant="contained"
                              onClick={handleDownload}
                              sx={{ mt: 0, backgroundColor: "#bb1ccc" }}
                            >
                              Download
                            </Button> */}
                    </div>
                  )}

                  <div style={{ display: "flex", gap: "10px",flexWrap:"wrap" }}>
                    {base64img && (
                      <>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img
                            width={400}
                            src={`${base64img}`}
                            alt="Uploaded"
                          />

                          <div>
                          <span style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  paddingBottom: "10px",
                                  paddingTop: "10px",
                                }}
                              >
                                Policy Compliance : {data.policy_compliance || 'N/A'}
                              </div>

                          
                            </span>

                            <span style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  paddingBottom: "10px",
                                }}
                              >
                                Display Type Result
                              </div>
                              <div
                                style={{
                                  background: "#eee",
                                  padding: "10px",
                                  borderRadius: "10px",
                                  display: "grid",
                                }}
                              >
                                {DisplayTypeResult && (
                                  <>
                                    <span>
                                      <b>Display Type</b> :{" "}
                                      <>
                                        {DisplayTypeResult["Display Type"] ||
                                          "N/A"}
                                      </>{" "}
                                    </span>

                                    <b>Reasoning:</b>
                                    <Markdown>
                                      {DisplayTypeResult.Reasoning}
                                    </Markdown>
                                  </>
                                )}
                              </div>
                            </span>

                            <span style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  paddingBottom: "10px",
                                  paddingTop: "10px",
                                }}
                              >
                                Compliance Assessment
                              </div>

                              {complianceAssessment &&
                                complianceAssessment !== null && (
                                  <div
                                    style={{
                                      background: "#eee",
                                      padding: "10px",
                                      borderRadius: "10px",
                                      display: "grid",
                                      fontSize: "16px",

                                    }}
                                  >
                                    <span>
                                      <b>Type</b> :{" "}
                                      <>
                                        {complianceAssessment.Compliance ||
                                          "N/A"}
                                      </>{" "}
                                    </span>
                                    <b>Reasons</b>
                                    <ul>
                                      <li>
                                        <b>Branding visibility </b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Branding visibility"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Clear signage</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Clear signage"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Clutter-free arrangement</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Clutter-free arrangement"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Easy customer access</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Easy customer access"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Neatness and stacking</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Neatness and stacking"
                                        ] || "N/A"}
                                      </li>
                                    </ul>

                                    {/* <Markdown>{data.compliance_assessment}</Markdown> */}
                                  </div>
                                )}
                            </span>
                       
                          </div>
                        </div>

                        <div style={{width:"100%"}}>
                            <span style={{ textAlign: "left",paddingTop:"10px",display:"block" }}>
                              <div
                                style={{
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  paddingBottom: "10px",
                                }}
                              >
                                Metadata
                              </div>
                              <div
                                style={{
                                  background: "#eee",
                                  padding: "10px",
                                  borderRadius: "10px",
                                  display: "grid",
                                }}
                              >
                                    <MetadataTable metadata={data.metadata || []} />

                              </div>
                            </span>

                           
                          </div>

                      </>
                    )}
                  </div>
                </div>
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default RetailDisplayChecker;
